<template>
  <el-dialog
    :model-value="props.visible"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    append-to-body
    class="transfer-reminder-dialog"
  >
    <div class="reminder-content">
      <p class="reminder-text" v-html="props.reminderData?.content"></p>
    </div>

    <template #footer>
      <el-button
        type="primary"
        class="confirm-btn"
        @click="handleConfirm"
      >
        前往操作
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    reminderData: {
        type: Object,
        required: false
    } 
})
const emit = defineEmits(['update:visible'])

const router = useRouter()
const handleConfirm = () => {
    let query = {
      key: "listStatistics",
      ownerid: props.reminderData?.resignUserId,
    };
    router.push({
      name: "Intention",
      query,
    });
     
    emit('update:visible', false)
}

</script>

<style lang="scss">
.transfer-reminder-dialog .el-dialog__header {
  padding: 0 !important;
  margin-bottom: 0 !important;
}
</style>

<style lang="scss" scoped>
.reminder-content {
  line-height: 1.8;
  color: #606266;
  font-size: 14px;

  .reminder-text {
    text-indent: 0;
    :deep(.normal) {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .reminder-text:last-child {
    margin-bottom: 0;
  }
}

.confirm-btn {
  min-width: 110px;
}
</style>

